var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutBoxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.92 19.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke-width:1.46px;}.d,.e{fill:none;stroke:#888;stroke-miterlimit:10;}.e{stroke-width:1.94px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M17.8,15.61c0,1.7-1.32,3.1-2.94,3.1H3.67c-1.62,0-2.94-1.39-2.94-3.1V3.83C.73,2.12,2.05,.73,3.67,.73H14.86c1.62,0,2.94,1.39,2.94,3.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "17.64 5.8 21.55 9.72 17.64 13.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 21.55,
    y1: 9.72,
    x2: 11.14,
    y2: 9.72
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutBoxy);
export default __webpack_public_path__ + "static/media/logoutBoxy.57983126f9c7df53cf199c72f19f47b3.svg";
export { ForwardRef as ReactComponent };